import { render, staticRenderFns } from "./OrderSummaryTaxes.vue?vue&type=template&id=b3a5515c&"
import script from "./OrderSummaryTaxes.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryTaxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports